/**
 * Security configuration for the application
 */
export const securityConfig = {
  // CSRF token header name
  csrfHeaderName: 'X-CSRF-TOKEN',
  
  // Token refresh settings
  tokenRefresh: {
    // How long before token expiry to refresh (in milliseconds)
    refreshBeforeExpiry: 60000, // 1 minute
    retryDelay: 5000, // 5 seconds between retries
  },
  
  // Cookie settings
  cookies: {
    // Cookie names
    accessTokenCookie: 'access_token',
    refreshTokenCookie: 'refresh_token',
    csrfCookie: 'csrf_token',
    
    // Cookie paths to clear on logout
    paths: ['/', '/api', '/api/v1'],
  },
  
  // Authentication endpoints
  endpoints: {
    login: '/auth/login',
    register: '/auth/register',
    verify: '/auth/verify',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    googleAuth: '/auth/oauth2/google',
    googleCallback: '/auth/oauth2/callback/google'
  },
};

export default securityConfig; 